import { ISectionProps } from '../section/interfaces';
import { IPatientMergeProps } from './interfaces';
import { Section } from '../section/section';

export const PatientMergeSection = (props: ISectionProps<IPatientMergeProps>) => Section<IPatientMergeProps>(props);
